import axios from "axios";


 const HTTP =  axios.create({
    baseURL: '/api/v1/',
    timeout: 120000,
    headers: {
        'Content-Type' : 'application/x-www-form-urlencoded',
    }
});

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    HTTP.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}



/*
HTTP.interceptors.response.use(
    function (response) {
        response.data.errors.forEach(function(error) {
            if (error.code === 'invalid_csrf' && error.customData.csrf)
            {
                BX.message({'bitrix_sessid': error.customData.csrf});
                return axios.request(response.config);
            }
        });
        return response;
    },
    function(err) {
        if(err.response.status === 401) {
            //window.location.href = "/auth";
        }
        return Promise.reject(err);
    }
);*/


 export {HTTP};